import { Component, OnInit } from '@angular/core';
import { navItems } from '../../_nav';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

import { NotificationService } from '../../shared/toastrservice.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  imgUrl: string = "assets/img/avatars/6.jpg";

  constructor(
    private router: Router,
    private toastr: NotificationService
  ) { }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  ngOnInit() {
    var loginData = JSON.parse(localStorage.getItem('loginData'));

    if (loginData.profile_picture != null || loginData.profile_picture != "") {
      this.imgUrl = loginData.profile_picture;
    }
  }

  open() {

    var x = document.getElementById("exampleModal");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }

  // logout() {
  //   localStorage.removeItem('loginData');
  //   this.router.navigate(['login']).then(() => {
  //     this.toastr.showSuccess("Logout successfully!", "Success");
  //   });
  // }


  logout() {
    swal.fire({
      title: "Are you sure, you want to logout?",
      // text: 'text',
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      confirmButtonColor: "#008000"
    })
      .then(result => {
        console.log(result)
        if (result.isDismissed == false) {
          localStorage.removeItem('loginData');
          this.router.navigate(['login']).then(() => {
            this.toastr.showSuccess("Logout successfully!", "Success");
          });
        } else {
          swal.fire("Fail");
        }

      });
  }
  updateUrl(e) {
    this.imgUrl = "assets/img/avatars/6.jpg";
  }


}
